import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

function DefesaAtaqueNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
                alt="AAPEQ"
                className="h-12 w-auto"
              />
            </Link>
          </div>

          <div className="hidden sm:flex items-center gap-6">
            <button
              onClick={() => navigate(-1)}
              className={`flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none ${
                isScrolled ? 'text-gray-700 hover:text-[#F05954]' : 'text-white hover:text-[#F05954]'
              }`}
            >
              <i className="ri-arrow-left-line text-base"></i>
              Voltar
            </button>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Defesa+e+Ataque+%E2%80%94+menu+superior+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F05954] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#d94943] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Entrar na AAPEQ
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="sm:hidden p-2 cursor-pointer"
          >
            <i
              className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
                isScrolled ? 'text-[#262364]' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-white border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => { setIsMobileMenuOpen(false); navigate(-1); }}
                className="flex items-center gap-2 text-gray-700 hover:text-[#F05954] text-sm font-medium transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
              <a
                href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Defesa+e+Ataque+%E2%80%94+menu+mobile+%E2%80%94+Quero+entrar+na+AAPEQ"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F05954] text-white px-5 py-3 rounded-full text-sm font-medium text-center hover:bg-[#d94943] transition-all cursor-pointer block"
              >
                Entrar na AAPEQ
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default function DefesaAtaquePage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const trabalhado = [
    'Técnicas de defesa pessoal',
    'Reação em situações de confronto',
    'Posicionamento físico estratégico',
    'Fortalecimento da base corporal',
    'Aumento da capacidade motora e física',
    'Fortalecimento das articulações',
    'Superação de medo e insegurança',
    'Aumento da vitalidade e disposição física',
    'Saúde física, mental e emocional'
  ];

  const objetivos = [
    'Controle pessoal',
    'Presença física e mental',
    'Capacidade de defesa real',
    'Reação consciente em situações de risco',
    'Fortalecimento do corpo e da mente',
    'Aumento da segurança e confiança pessoal'
  ];

  const paraQuem = [
    { icon: 'ri-user-line', text: 'Homens e mulheres que desejam aprender defesa pessoal' },
    { icon: 'ri-shield-check-line', text: 'Pessoas que buscam mais segurança e confiança' },
    { icon: 'ri-user-star-line', text: 'Jovens a partir de 12 anos de idade' },
    { icon: 'ri-briefcase-line', text: 'Profissionais que desejam ampliar capacidade física e mental' }
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <DefesaAtaqueNavbar />

      {/* Banner */}
      <div className="relative w-full h-[260px] sm:h-[300px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/ed1e33276eee175ab8079a332dc18f82.jpg"
          alt="Defesa e Ataque Pessoal — AAPEQ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center px-5 text-center">
          <div className="inline-block bg-[#F05954] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Autoproteção
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Defesa e Ataque Pessoal — AAPEQ
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-3 max-w-xl">
            Autoproteção, controle e força de reação
          </p>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto">

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              O treinamento de Defesa e Ataque Pessoal foi desenvolvido para ensinar técnicas práticas de proteção e reação em situações de confronto ou necessidade de autoproteção.
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              O processo prepara o participante para agir com consciência, controle emocional e capacidade física em momentos de embate direto.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-star-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">O Que É Trabalhado</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {trabalhado.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg">
                  <span className="text-[#F05954] flex-shrink-0 mt-0.5">✔</span>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-sword-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Base Técnica</h2>
            </div>
            <div className="bg-gradient-to-br from-[#262364] to-[#1a1847] text-white p-8 rounded-2xl">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-sword-line text-2xl text-[#F05954]"></i>
                </div>
                <h3 className="text-xl font-bold">Fundamentos Orientais — Bushidō</h3>
              </div>
              <p className="text-sm leading-relaxed mb-6 text-white/90">
                O treinamento possui fundamentos de artes marciais e princípios orientais baseados no <strong>Bushidō</strong>, tradição japonesa voltada para disciplina, respeito, integridade e autocontrole.
              </p>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-star-line text-2xl text-[#F05954]"></i>
                </div>
                <h3 className="text-xl font-bold">Jiu-Jitsu Faixa Preta</h3>
              </div>
              <p className="text-sm leading-relaxed text-white/90">
                Também utiliza técnicas aplicadas de <strong>Jiu-Jitsu faixa preta</strong>, reconhecido mundialmente como uma das artes marciais mais eficientes para defesa pessoal e controle físico em situações de confronto.
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-fire-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Objetivo do Treinamento</h2>
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">O objetivo é desenvolver:</p>
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {objetivos.map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg border-l-4 border-[#F05954]">
                  <i className="ri-checkbox-circle-fill text-xl text-[#F05954] flex-shrink-0 mt-0.5"></i>
                  <p className="text-sm text-gray-700 font-semibold">{item}</p>
                </div>
              ))}
            </div>
            <div className="bg-[#262364] text-white p-5 sm:p-6 rounded-xl">
              <p className="text-base font-semibold">
                Além disso, o participante aprende técnicas práticas de artes marciais aplicadas à defesa e ao ataque pessoal, ampliando sua capacidade de reação e autoproteção.
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 px-5 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-group-line text-2xl text-[#F05954]"></i>
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-[#262364]">Para Quem É Este Treinamento</h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-6">
              {paraQuem.map((item, index) => (
                <div key={index} className="flex items-start gap-4 bg-gray-50 p-6 rounded-xl hover:bg-gray-100 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#262364] rounded-full flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <p className="text-sm text-gray-700 mt-2">{item.text}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 bg-[#F05954]/10 border-l-4 border-[#F05954] p-6 rounded-lg">
              <p className="text-sm text-gray-700 font-semibold">
                Não é necessário ter experiência prévia em artes marciais.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 sm:py-20 px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-[#262364] mb-6">
              Pronto para aprender a se defender com consciência e força real?
            </h2>
            <a
              href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pela+p%C3%A1gina+de+Defesa+e+Ataque+%E2%80%94+CTA+final+%E2%80%94+Quero+entrar+na+AAPEQ"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-6 py-4 rounded-full text-base font-semibold hover:bg-[#262364] transition-all cursor-pointer mx-4 sm:mx-0"
            >
              Entrar na AAPEQ — Defesa e Ataque Pessoal
            </a>
            <div className="mt-8">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#262364] transition-colors cursor-pointer bg-transparent border-none"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar
              </button>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
